import React, { Component, useEffect, useState } from "react";
import {} from "../../core/feature/store";
import { useAppSelector, useAppDispatch } from "../../core/feature/hooks";
import Company from "../../core/models/company";
import { Link, useLocation, useNavigate, useParams } from "react-router-dom";
import User from "../../core/models/user";
import _, { find } from "lodash";
import "react-multi-carousel/lib/styles.css";
import * as api_info from "../../core/service/api_info";
import Config from "../../config/Config";
import userweb from "../../assets/images/icon_home/userweb.svg";
import dot from "../../assets/images/icon_home/dot-balance.svg";
import kanan from "../../assets/images/icon_home/tangankanan.svg";
import kiri from "../../assets/images/icon_home/tangankiri.svg";
import logo from "../../assets/images/icon_home/logoweb.svg";
import notif from "../../assets/images/icon_home/notif.svg";
import Navbar from "../common/Navbar";
import moment from "moment";
import bola from "../../assets/images/info/bola.svg";
import { BrowserView, MobileView } from "react-device-detect";
import { StatsInformasi } from "../common/home/Stats";
import { Swiper, SwiperSlide } from "swiper/react";
import {
  EffectCards,
  EffectCoverflow,
  Keyboard,
  Navigation,
  Pagination,
} from "swiper";
import { useTranslation } from "react-i18next";
import { Transition } from "@headlessui/react";
import { Typography } from "@material-tailwind/react";
import { BackButton } from "../common/BackButton";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faChevronLeft } from "@fortawesome/free-solid-svg-icons";
import ReactGA from "react-ga4";

const InfoDetailWeb = () => {
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const company: Company = useAppSelector((state) => state.company.company);
  const user: User = useAppSelector((state) => state.user.user);
  const [pages, setPage] = useState(0);
  const [lastPage, setLastPage] = useState(0);
  let [isOpen, setIsOpen] = useState(true);
  let [loading, setLoading] = useState(false);
  let [noData, setNoData] = useState(false);
  const [tags, setTags] = useState<any>([]);
  const [selectedTags, setSelectedTags] = useState<any>([]);
  // const [selected, setSelected] = useState(people[0]);
  const { t } = useTranslation();
  const [imgShow, setImgShow] = useState(false);
  const [imgView, setImgView] = useState<any>({});

  const location = useLocation();
  const { cid } = useParams();

  const [pathName, setPathName] = useState(
    location.pathname.replaceAll("/", "").toUpperCase()
  );
  const env = Config.BaseUrlDev;
  const goToTop = () => {
    try {
      window.scrollTo({
        top: 0,
        behavior: "smooth",
      });
    } catch (error) {
      window.scrollTo(0, 0);
    }
  };

  useEffect(() => {
    setTimeout(() => {
      goToTop();
      console.log("to top");
    }, 100);
    setTimeout(() => {
      window.scroll({
        top: 0,
        left: 0,
        behavior: "smooth",
      });
    }, 0);
    getDetail();
    ReactGA.send({
      hitType: "pageview",
      page: window.location.pathname + window.location.search,
      title: "News & Info Detail",
    });
  }, []);

  const [data, setData] = useState({
    createTime: "2022-10-03T11:19:19",
    updateTime: "2022-10-10T10:58:36",
    companyId: "5f83b9fa28f6ab6e77b810d4",
    accountId: "5f83b9fb28f6ab6e77b810eb",
    isDeleted: false,
    title: "info",
    subtitle: "berita",
    isOpen: true,
    isHeadline: false,
    showTime: null,
    enable: false,
    tags: ["info", " siswa baru 7a", "11a"],
    description: "",
    viewCount: 0,
    urlFb: null,
    urlIg: null,
    urlDownload: null,
    latitude: null,
    longitude: null,
    image: "",
    imageOpt: ["", ""],
    isVideo: false,
    videoUrl: "",
    valueAdd: [],
    isAction: false,
    action: {
      name: null,
      inputValue: null,
      question: null,
      option: [],
      answer: null,
    },
    _id: "633a62c7ec01b49cdb3a521a",
  });

  const [imgOpt, setImgOpt] = useState<any>([]);
  const { id } = useParams();

  function getDetail() {
    api_info
      .getDetailInfo(id)
      .then((res: any) => {
        console.log(res.data);
        setData(res.data);
        setImgOpt(res.data.imageOpt);
        console.log(
          imgOpt.length + data.image.length + data.videoUrl.length,
          "njajal"
        );
      })
      .catch((e: any) => {
        navigate("/login", { replace: true });
      });
  }

  function getImgContent(url: string) {
    return env + "main_a/image/get/" + url + "/pas";
  }

  function getYtCode(str: String) {
    var regExp =
      /^.*(youtu\.be\/|v\/|u\/\w\/|embed\/|watch\?v=|\&v=)([^#\&\?]*).*/;
    var match = str.match(regExp);
    let x = "";
    if (match && match[2].length == 11) {
      x = match[2];
    } else {
      //error
    }
    return String(x)
      .replace("/", "")
      .replace("v=", "")
      .replace("?", "")
      .replace("#", "");
  }
  useEffect(() => {
    setTimeout(() => {
      goToTop();
      console.log("to top");
    }, 100);
    setTimeout(() => {
      window.scroll({
        top: 0,
        left: 0,
        behavior: "smooth",
      });
    }, 0);
    getDetail();
  }, []);

  const imgCliked = async (data: any) => {
    setImgShow(true);
    setImgView(data);
    console.log(data, "tes");
  };

  return (
    <>
      <div className="flex flex-col relative h-full w-full bg-psp-primary font-montserrat pb-20">
        <StatsInformasi />
        <div className="mx-auto z-50 container h-full md:-mt-30 -mt-32 bg-white flex-row  shadow rounded-2xl pb-10 p-4">
          <div className="flex">
            <button
              onClick={() => {
                navigate("/info");
              }}
              className="h-auto w-auto px-3 py-2 bg-white rounded-lg justify-center items-center mr-2"
            >
              <FontAwesomeIcon
                size="1x"
                icon={faChevronLeft}
                className=" cursor-pointer"
              />
            </button>
            <h1 className="text-4xl font-bold">{t("BERITA.title")}</h1>
          </div>
          <Swiper
            onSlideChange={(e) => {}}
            onSwiper={(swiper) => console.log(swiper)}
            effect={"coverflow"}
            grabCursor={true}
            centeredSlides={true}
            pagination={true}
            loop={false}
            keyboard={{
              enabled: true,
            }}
            centeredSlidesBounds={false}
            slidesPerView={
              imgOpt?.length + data.image?.length + data.videoUrl?.length === 0
                ? 1
                : 3
            }
            navigation={true}
            onScroll={(e) => {
              console.log(e);
            }}
            coverflowEffect={{
              rotate: 0,
              stretch: 80,
              depth: 100,
              modifier: 1.5,
              slideShadows: false,
            }}
            modules={[EffectCoverflow, Navigation, Keyboard]}
            className="w-full h-auto relative items-center justify-center py-5"
          >
            {data.image && (
              <SwiperSlide className="flex justify-center relative  w-full h-auto items-center overflow-visible ">
                <div className=" w-auto h-auto relative">
                  <img
                    onClick={() => imgCliked(data.image)}
                    className="w-auto h-auto max-w-[45vh] max-h-[40vh] block object-fit rounded-xl shadow"
                    src={getImgContent(data.image)}
                    alt=""
                  />
                  {/* <LazyLoadImage
                    className="h-full w-full"
                    effect="blur"
                    src={getImgContent(data.image)}
                  /> */}
                </div>
              </SwiperSlide>
            )}
            {imgOpt?.length > 0 &&
              imgOpt.map((item: any, i: any) => {
                return (
                  <SwiperSlide className="flex justify-center relative  w-full h-auto items-center overflow-visible ">
                    <div key={i} className=" w-auto h-auto  relative ">
                      <img
                        onClick={() => imgCliked(item)}
                        className="w-auto h-auto max-w-[45vh] max-h-[40vh] block object-fit rounded-xl shadow"
                        src={getImgContent(item)}
                        alt=""
                      />
                      {/* <LazyLoadImage
                        className="h-full w-full"
                        effect="blur"
                        src={getImgContent(item)}
                      /> */}
                    </div>
                  </SwiperSlide>
                );
              })}
            {data.videoUrl && (
              <SwiperSlide className="flex justify-center relative  w-full h-auto items-center overflow-visible">
                <div className=" w-auto h-auto  relative ">
                  <iframe
                    allow="fullscreen"
                    onClick={() => imgCliked(data.videoUrl)}
                    className="max-w-[50vh] max-h-[40vh] min-w-[50vh] min-h-[35vh] block object-fit rounded-xl shadow"
                    width="100%"
                    height="100%"
                    src={`https://www.youtube.com/embed/${getYtCode(
                      data.videoUrl
                    )}`}
                  ></iframe>
                </div>
              </SwiperSlide>
            )}
          </Swiper>
          <div className="mt-2 mb-4 px-5 flex relative w-full justify-start flex-col">
            <h5 className="font-montserrat m-0 font-normal text-sm text-slate-400">
              {moment(data.updateTime).format("DD MMMM YYYY")}
            </h5>
            <h1 className="font-montserrat m-0 font-bold text-xl text-black  ">
              {data.title}
            </h1>
            <h5 className="font-montserrat m-0 text-sm text-black font-semibold">
              {data.subtitle}
            </h5>

            <div className="mt-4">
              <Typography variant="paragraph">
                <p
                  className="text-lg whitespace-pre-wrap text-justify"
                  dangerouslySetInnerHTML={{ __html: data.description }}
                />
              </Typography>
            </div>
          </div>
        </div>
        <Transition
          show={imgShow}
          enter="transition-opacity duration-100"
          enterFrom="opacity-0"
          enterTo="opacity-100"
          leave="transition-opacity duration-150"
          leaveFrom="opacity-100"
          leaveTo="opacity-0"
        >
          <>
            <div className="justify-center items-center flex overflow-x-hidden overflow-y-auto fixed inset-0 z-50 outline-none focus:outline-none font-montserrat ">
              <button
                className="py-2 px-3 border-2 rounded-md text-black font-bold text-xl bg-white absolute right-5 top-5"
                onClick={() => setImgShow(false)}
              >
                X
              </button>
              <div className="relative w-auto h-auto my-6 mx-auto max-w-6xl">
                <div className="relative flex flex-col w-full bg-transparent outline-none focus:outline-none">
                  <div className="bg-white">
                    <img
                      src={getImgContent(imgView)}
                      alt=""
                      className="w-[40vh]"
                    />
                  </div>
                </div>
              </div>
            </div>
            <div className="opacity-25 fixed inset-0 z-40 bg-black"></div>
          </>
        </Transition>
      </div>
    </>
  );
};

export default InfoDetailWeb;
